import * as React from 'react';
import { styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import AddSharpIcon from '@mui/icons-material/AddSharp';
import AddAPhotoSharpIcon from '@mui/icons-material/AddAPhotoSharp';
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'
import { Context, getRollbarFromContext } from '@rollbar/react';
import BarcodeScanner from './BarcodeScanner';

const Input = styled('input')({
    display: 'none',
  });

class PatternChecker extends React.Component {
    static contextType = Context;

    constructor(props) {
        super(props);
        this.state = { 
            userIdToken: this.props.userIdToken,
            loadingFromApiCheck: false,
            loadingFromApiAdd: false,
            hasSearched: false,
            patternAdded: false,
            checkError: false,
            addError: false,
            scanMethod: 0, // 0 = camera, 1 = upload
            manualUpc: ''
        };
      }
    
    // Handle barcode scanned from camera
    handleCameraScan = (barcode) => {
        console.log('Camera scanned barcode:', barcode);
        this.checkPattern(barcode);
    };

    // Check pattern by UPC (from camera or manual entry)
    checkPattern = (upc) => {
        this.setState({
            loadingFromApiCheck: true,
            checkError: false,
            hasSearched: false
        });

        var rollbar = getRollbarFromContext(this.context);
        var apiHeaders = new Headers();
        apiHeaders.append('Authorization', 'Bearer ' + this.state.userIdToken);
        apiHeaders.append('Content-Type', 'application/json');

        var url = process.env.REACT_APP_API_HOSTNAME + "/patterns/check/upc/" + encodeURIComponent(upc);
        
        fetch(url, {
            headers: apiHeaders,
            method: "GET"
        })
        .then(response => {
            response.json().then(responseJson => {
                if (!response.ok) {
                    this.setState({
                        checkError: true,
                        checkErrorMessage: "Error checking pattern: " + (responseJson.title || 'Unknown error'),
                        hasSearched: false,
                        loadingFromApiCheck: false
                    });
                    rollbar.error(response);
                } else {
                    this.setState({
                        hasSearched: true,
                        result: responseJson,
                        patternAdded: false,
                        loadingFromApiCheck: false
                    });
                }
            });
        })
        .catch(error => {
            this.setState({
                checkError: true,
                checkErrorMessage: error.message,
                loadingFromApiCheck: false
            });
            rollbar.error(error);
        });
    };
    
    uploadPhoto = (event) => {
        this.setState({
            loadingFromApiCheck: true,
            checkError: false
        })

        var rollbar = getRollbarFromContext(this.context);

        var apiHeaders = new Headers();
        apiHeaders.append('Authorization', 'Bearer ' + this.state.userIdToken);

        var data = new FormData();
        data.append( "upcImage", event.target.files[0] );
        var url = process.env.REACT_APP_API_HOSTNAME + "/patterns/check";
        fetch(url,
        {
            headers: apiHeaders,
            method: "POST",
            body: data
        })
        .then(response => {
            response.json().then(responseJson => {
                if (!response.ok) {
                    if (response.status === 400) {
                        if (responseJson.title === "Unreadable") {
                            this.setState({
                                checkError: true,
                                checkErrorMessage: "Unable to read a barcode in the image, please try a different photo",
                                hasSearched: false,
                                loadingFromApiCheck: false
                            });
                        }
                        else if (responseJson.title === "Error") {
                            this.setState({
                                checkError: true,
                                checkErrorMessage: "There was an error reading the image, try again or try a different photo",
                                hasSearched: false,
                                loadingFromApiCheck: false
                            });
                        }
                        else {
                            this.setState({
                                checkError: true,
                                checkErrorMessage: "There was an unknown error reading the image, try again or try a different photo",
                                hasSearched: false,
                                loadingFromApiCheck: false
                            });
                           
                            rollbar.error(response);
                        }
                    }
                    else if (response.status === 500) {
                        this.setState({
                            checkError: true,
                            checkErrorMessage: "Server error: " + response.text(),
                            hasSearched: false,
                            loadingFromApiCheck: false
                        });

                        rollbar.error(response);
                    }
                }
                else {
                    this.setState({
                        hasSearched: !this.state.checkError && true,
                        result: responseJson,
                        patternAdded: false,
                        loadingFromApiCheck: false
                    });

                    rollbar.error(responseJson);
                }
            })
        })
        .catch(error => {
            this.setState({
                checkError: true,
                checkErrorMessage: error + " / " + this.state.checkErrorMessage
            });

            rollbar.error(error);
        })
    }

    addPattern = () => {
        this.setState({
            loadingFromApiAdd: true
        })

        var rollbar = getRollbarFromContext(this.context);

        var apiHeaders = new Headers();
        apiHeaders.append('Authorization', 'Bearer ' + this.state.userIdToken);

        var data = new FormData();
        data.append("upc", this.state.result.pattern.upc);
        
        // Add metadata if available
        if (this.state.result.pattern.title) {
            data.append("title", this.state.result.pattern.title);
        }
        if (this.state.result.pattern.description) {
            data.append("description", this.state.result.pattern.description);
        }
        if (this.state.result.pattern.brand) {
            data.append("brand", this.state.result.pattern.brand);
        }
        if (this.state.result.pattern.imageUrl) {
            data.append("imageUrl", this.state.result.pattern.imageUrl);
        }
        
        var url = process.env.REACT_APP_API_HOSTNAME + "/patterns";
        fetch(url,
        {
            headers: apiHeaders,
            method: "PUT",
            body: data
        })
        .then(response => {
            response.json().then(responseJson => {
                if (!response.ok) {
                    if (response.status === 400) {
                        if (responseJson.title === "NullPattern") {
                            this.setState({
                                addError: true,
                                addErrorMessage: "Error adding pattern, pattern was empty",
                                loadingFromApiAdd: false
                            });
                        }
                        else if (responseJson.title === "Unexpected") {
                            this.setState({
                                addError: true,
                                addErrorMessage: "Unexpected error adding pattern to bin",
                                loadingFromApiAdd: false
                            });

                            rollbar.error(response);
                        }
                        else {
                            this.setState({
                                addError: true,
                                addErrorMessage: "Unknown error adding pattern to bin",
                                loadingFromApiAdd: false
                            });

                            rollbar.error(response);
                        }
                    }
                    else if (response.status === 500) {
                        this.setState({
                            addError: true,
                            addErrorMessage: "Server error: " + response.text(),
                            loadingFromApiAdd: false
                        });

                        rollbar.error(response);
                    }
                }
                else {
                    this.setState({
                        hasSearched: true,
                        patternAdded: true,
                        loadingFromApiAdd: false
                    });

                    rollbar.error(responseJson);
                }
            })
            if (!response.ok) {
                if (response.status === 400) {
                    this.setState({
                        addError: true,
                        addErrorMessage: "Error adding pattern, pattern was null"
                    });
                }
                else if (response.status === 500) {
                    this.setState({
                        addError: true,
                        addErrorMessage: "Unexpected server error: " + response.text()
                    });
                    rollbar.error(response);
                }
                else {
                    this.setState({
                        addError: true,
                        addErrorMessage: "Unexpected server error: " + response.text()
                    });
                    rollbar.error(response);
                }
            }
            
            return response;
        })
        .catch(error => {
            this.setState({
                addError: true,
                addErrorMessage: error + " / " + this.state.addErrorMessage,
                loadingFromApiAdd: false
            });

            rollbar.error(error);
        })
    }

    render() {
        const { scanMethod } = this.state;

        return  <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ px: { xs: 2, sm: 0 } }}>
                    <Paper sx={{ p: { xs: 2, sm: 3 }, width: '100%', maxWidth: 600 }}>
                        <Stack spacing={3} alignItems="center" justifyContent="center" >
                            <Typography variant="h5" color="text.primary" align="center" fontWeight={600} letterSpacing="-0.01em">
                                Scan Pattern Barcode
                            </Typography>
                            
                            { this.state.checkError && 
                                <Box 
                                    sx={{ 
                                        bgcolor: 'error.light', 
                                        color: 'error.dark',
                                        p: 2, 
                                        borderRadius: 2,
                                        width: '100%',
                                    }}
                                >
                                    <Typography variant="body2" align="center" fontWeight={500}>
                                        { this.state.checkErrorMessage }
                                    </Typography>
                                </Box>
                            }

                            {/* Tabs for scan method selection */}
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
                                <Tabs 
                                    value={scanMethod} 
                                    onChange={(e, newValue) => this.setState({ scanMethod: newValue })}
                                    centered
                                    textColor="primary"
                                    indicatorColor="primary"
                                >
                                    <Tab label="Camera" sx={{ fontWeight: 600, fontSize: '0.95rem' }} />
                                    <Tab label="Upload Photo" sx={{ fontWeight: 600, fontSize: '0.95rem' }} />
                                    <Tab label="Enter Manually" sx={{ fontWeight: 600, fontSize: '0.95rem' }} />
                                </Tabs>
                            </Box>

                            {/* Camera Scanner */}
                            {scanMethod === 0 && (
                                <BarcodeScanner onScanSuccess={this.handleCameraScan} />
                            )}

                            {/* Photo Upload */}
                            {scanMethod === 1 && (
                                <Box sx={{ textAlign: 'center', py: 2 }}>
                                    <label htmlFor="contained-button-file">
                                        <Input accept="image/*" id="contained-button-file" type="file" capture="environment" onChange={this.uploadPhoto}/>
                                        <LoadingButton 
                                            variant='contained' 
                                            color="primary" 
                                            loading={this.state.loadingFromApiCheck} 
                                            sx={{ 
                                                fontSize: "1rem",
                                                fontWeight: 600,
                                                minWidth: 200,
                                                py: 1.5,
                                            }} 
                                            endIcon={<AddAPhotoSharpIcon />} 
                                            component="span"
                                        >
                                            Upload Photo
                                        </LoadingButton>
                                    </label>
                                    <Typography variant="body2" display="block" color="text.secondary" sx={{ mt: 2 }}>
                                        Take a clear photo of the barcode
                                    </Typography>
                                </Box>
                            )}

                            {/* Manual Entry */}
                            {scanMethod === 2 && (
                                <Box sx={{ width: '100%', textAlign: 'center', py: 2 }}>
                                    <TextField
                                        label="Enter UPC code"
                                        id="manual-upc-input"
                                        fullWidth
                                        value={this.state.manualUpc}
                                        onChange={(e) => this.setState({ manualUpc: e.target.value })}
                                        sx={{ mb: 3 }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">
                                                <FontAwesomeIcon icon={faBarcode} size="lg"/>
                                            </InputAdornment>,
                                        }}
                                    />
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        loading={this.state.loadingFromApiCheck}
                                        onClick={() => this.checkPattern(this.state.manualUpc)}
                                        disabled={!this.state.manualUpc}
                                        sx={{
                                            fontWeight: 600,
                                            minWidth: 200,
                                            py: 1.5,
                                        }}
                                    >
                                        Check Pattern
                                    </LoadingButton>
                                </Box>
                            )}
                        </Stack>
                    </Paper>
                    { this.state.hasSearched && 
                        <Paper 
                            sx={{ 
                                p: 3,
                                animation: 'fadeSlideIn 0.5s ease-out',
                                '@keyframes fadeSlideIn': {
                                    '0%': {
                                        opacity: 0,
                                        transform: 'translateY(-20px)',
                                    },
                                    '100%': {
                                        opacity: 1,
                                        transform: 'translateY(0)',
                                    },
                                },
                            }}
                        >
                            <Stack spacing={3} alignItems="center" justifyContent="center" >
                                { this.state.addError && 
                                    <Typography variant="subtitle2" color="error" align="center">
                                        { this.state.addErrorMessage }
                                    </Typography>
                                }
                                { this.state.result.exists && 
                                    <Box 
                                        sx={{ 
                                            textAlign: 'center',
                                            animation: 'successPulse 0.6s ease-in-out',
                                            '@keyframes successPulse': {
                                                '0%': { transform: 'scale(1)' },
                                                '50%': { transform: 'scale(1.05)' },
                                                '100%': { transform: 'scale(1)' },
                                            },
                                        }}
                                    >
                                        <CheckBoxSharpIcon 
                                            sx={{ 
                                                fontSize: 60, 
                                                color: 'success.main',
                                                mb: 1,
                                            }}
                                        />
                                        <Typography variant="h5" color="success.main" align="center" fontWeight={600}>
                                            Already in Bin
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                                            This pattern is already in your collection
                                        </Typography>
                                    </Box>
                                }
                                { !this.state.result.exists && !this.state.patternAdded &&
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography variant="h6" color="text.primary" align="center" sx={{ mb: 2 }}>
                                            Pattern Not Found in Bin
                                        </Typography>
                                        <LoadingButton 
                                            variant='contained' 
                                            color="primary" 
                                            loading={this.state.loadingFromApiAdd} 
                                            sx={{ 
                                                fontSize: "medium",
                                                minWidth: 160,
                                                py: 1.5,
                                            }} 
                                            component="span" 
                                            onClick={this.addPattern} 
                                            endIcon={<AddSharpIcon />}
                                        >
                                            Add to Bin
                                        </LoadingButton>
                                    </Box>
                                }
                                { this.state.patternAdded &&
                                    <Box 
                                        sx={{ 
                                            textAlign: 'center',
                                            animation: 'successPulse 0.6s ease-in-out',
                                            '@keyframes successPulse': {
                                                '0%': { transform: 'scale(1)' },
                                                '50%': { transform: 'scale(1.05)' },
                                                '100%': { transform: 'scale(1)' },
                                            },
                                        }}
                                    >
                                        <CheckBoxSharpIcon 
                                            sx={{ 
                                                fontSize: 60, 
                                                color: 'success.main',
                                                mb: 1,
                                            }}
                                        />
                                        <Typography variant="h5" color="success.main" align="center" fontWeight={600}>
                                            Added to Bin!
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                                            Pattern successfully saved
                                        </Typography>
                                    </Box>
                                }
                                <Divider variant="fullWidth" flexItem sx={{ my: 2 }}>
                                    <Typography variant="subtitle2" color="text.secondary" align="center" fontWeight={500}>
                                        PATTERN DETAILS
                                    </Typography>
                                </Divider>

                                <Stack spacing={2} sx={{ width: '100%' }}>
                                    {this.state.result.pattern.imageUrl && (
                                        <Box 
                                            sx={{ 
                                                display: 'flex', 
                                                justifyContent: 'center',
                                                mb: 2,
                                            }}
                                        >
                                            <img 
                                                src={this.state.result.pattern.imageUrl} 
                                                alt={this.state.result.pattern.title || 'Product'}
                                                style={{
                                                    maxWidth: '200px',
                                                    maxHeight: '200px',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                }}
                                            />
                                        </Box>
                                    )}

                                    {this.state.result.pattern.title && (
                                        <Box sx={{ bgcolor: 'primary.light', p: 2, borderRadius: 2 }}>
                                            <Typography variant="caption" color="primary.dark" fontWeight={600}>
                                                TITLE
                                            </Typography>
                                            <Typography variant="body1" color="text.primary" fontWeight={500}>
                                                {this.state.result.pattern.title}
                                            </Typography>
                                        </Box>
                                    )}

                                    {this.state.result.pattern.brand && (
                                        <Box sx={{ bgcolor: 'secondary.light', p: 2, borderRadius: 2 }}>
                                            <Typography variant="caption" color="secondary.dark" fontWeight={600}>
                                                BRAND
                                            </Typography>
                                            <Typography variant="body1" color="text.primary" fontWeight={500}>
                                                {this.state.result.pattern.brand}
                                            </Typography>
                                        </Box>
                                    )}

                                    {this.state.result.pattern.description && (
                                        <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 2 }}>
                                            <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                                DESCRIPTION
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {this.state.result.pattern.description}
                                            </Typography>
                                        </Box>
                                    )}

                                    <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 2 }}>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                            UPC
                                        </Typography>
                                        <Typography variant="body1" color="text.primary" fontFamily="monospace">
                                            {this.state.result.pattern.upc}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Stack>
                        </Paper>
                    }
                </Stack>
  }
}

export default PatternChecker